var _path, _g, _path2, _path3, _g2, _g3, _path4, _g4, _path5, _path6, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 89,
    viewBox: "0 0 153 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.393 68.9937C113.979 75.2033 126.784 72.4661 132.994 62.8801C139.203 53.294 136.466 40.4892 126.88 34.2796C117.294 28.07 104.489 30.8072 98.2795 40.3932C92.0699 49.9793 94.8071 62.7842 104.393 68.9937Z",
    fill: "#FFD880"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2597_14469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.73 63.4024C135.16 56.282 134.601 45.2971 127.48 38.8669C120.36 32.4368 109.375 32.9963 102.945 40.1167C96.5149 47.2371 97.0744 58.222 104.195 64.6521C111.315 71.0823 122.3 70.5228 128.73 63.4024Z",
    fill: "#D29400"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.033 65.5931C120.678 66.961 127.985 61.8722 129.353 54.2269C130.72 46.5817 125.632 39.2752 117.986 37.9074C110.341 36.5395 103.035 41.6283 101.667 49.2736C100.299 56.9188 105.387 64.2253 113.033 65.5931Z",
    fill: "#FFCA2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2597_14469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 37,
    width: 29,
    height: 29
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.037 65.5936C120.682 66.9615 127.989 61.8727 129.357 54.2274C130.725 46.5822 125.636 39.2757 117.991 37.9078C110.345 36.54 103.039 41.6288 101.671 49.274C100.303 56.9193 105.392 64.2258 113.037 65.5936Z",
    fill: "#FFCA2D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2597_14469)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2597_14469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.746 46.3407C107.406 49.9524 108.527 54.8442 112.127 57.2462L125.233 65.736L127.219 62.6704L114.393 54.3627C112.401 53.0719 111.589 50.2727 112.868 48.2974C114.148 46.3221 116.8 45.7671 118.793 47.0578C120.785 48.3486 121.363 50.9961 120.084 52.9714C119.22 54.3052 117.73 54.9915 116.239 54.899L120.306 57.533C121.385 56.9317 122.335 56.0669 123.052 54.9602C125.412 51.3175 124.346 46.435 120.672 44.0548C116.997 41.6745 112.106 42.698 109.746 46.3407Z",
    fill: "#D29400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.845 50.1208C107.682 51.984 108.192 53.8689 109.294 55.4115L98.85 48.646L100.836 45.5804L107.845 50.1208Z",
    fill: "#D29400"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2597_14469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2453 69.5877L86.8227 59.2456C92.9722 58.141 98.4314 54.6395 102 49.511C105.569 44.3825 106.955 38.0468 105.853 31.8967C104.749 25.7472 101.247 20.2881 96.1187 16.7195C90.9902 13.1508 84.6544 11.7649 78.5044 12.8662L20.9141 23.1964C14.7646 24.301 9.30545 27.8025 5.73683 32.931C2.1682 38.0595 0.782229 44.3952 1.88361 50.5453C2.42911 53.5926 3.56967 56.5025 5.24014 59.1089C6.9106 61.7153 9.07823 63.967 11.6192 65.7354C14.1601 67.5038 17.0246 68.7542 20.049 69.4152C23.0733 70.0762 26.1983 70.1348 29.2453 69.5877Z",
    fill: "#9E55CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3001 64.4109L84.9716 54.3961C89.9337 53.508 94.3398 50.6852 97.2207 46.5487C100.102 42.4121 101.221 37.3006 100.334 32.3384C99.4456 27.3763 96.6229 22.9702 92.4863 20.0893C88.3497 17.2084 83.2382 16.0886 78.2761 16.9763L22.5984 26.9914C20.1407 27.4296 17.7935 28.3479 15.6909 29.694C13.5884 31.04 11.7718 32.7872 10.3451 34.8358C8.91834 36.8844 7.9094 39.1942 7.37597 41.633C6.84254 44.0718 6.79508 46.5919 7.2363 49.049C7.67449 51.5073 8.59307 53.8551 9.93951 55.9581C11.2859 58.0611 13.0338 59.8779 15.0831 61.3047C17.1323 62.7315 19.4428 63.7403 21.8824 64.2733C24.3219 64.8063 26.8425 64.853 29.3001 64.4109Z",
    fill: "#40256B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3279 37.0818L20.5425 37.9414L23.5732 54.8124L28.3586 53.9528L25.3279 37.0818Z",
    fill: "#FB7BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4555 42.0391L15.5845 45.0698L16.4441 49.8552L33.3152 46.8245L32.4555 42.0391Z",
    fill: "#FB7BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1685 30.0785C85.2537 30.5517 85.1968 31.0395 85.0048 31.4803C84.8128 31.9211 84.4944 32.2951 84.0899 32.5549C83.6853 32.8148 83.2129 32.9488 82.7321 32.9402C82.2514 32.9315 81.7841 32.7805 81.3892 32.5062C80.9943 32.2319 80.6896 31.8467 80.5136 31.3992C80.3377 30.9518 80.2984 30.4622 80.4006 29.9924C80.5029 29.5226 80.7422 29.0937 81.0882 28.7599C81.4343 28.4261 81.8715 28.2024 82.3447 28.1171C82.6589 28.0605 82.9812 28.0663 83.2931 28.1342C83.6051 28.2021 83.9006 28.3308 84.1628 28.5129C84.425 28.6951 84.6488 28.9271 84.8214 29.1957C84.9939 29.4643 85.1119 29.7643 85.1685 30.0785Z",
    fill: "#FB7BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9588 39.9252C87.043 40.3986 86.985 40.8864 86.7919 41.3268C86.5989 41.7672 86.2796 42.1405 85.8744 42.3995C85.4692 42.6584 84.9963 42.7914 84.5156 42.7815C84.0348 42.7717 83.5678 42.6195 83.1735 42.3442C82.7793 42.0688 82.4755 41.6828 82.3007 41.2348C82.1259 40.7868 82.0878 40.2971 82.1914 39.8275C82.295 39.3579 82.5355 38.9296 82.8825 38.5967C83.2295 38.2638 83.6675 38.0413 84.141 37.9574C84.4553 37.9 84.778 37.9054 85.0902 37.9735C85.4025 38.0415 85.6982 38.1707 85.9602 38.3537C86.2222 38.5367 86.4454 38.7697 86.6168 39.0395C86.7882 39.3092 86.9044 39.6102 86.9588 39.9252Z",
    fill: "#FB7BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0135 36.9431C88.5403 37.0283 88.0525 36.9713 87.6117 36.7793C87.1709 36.5874 86.7969 36.269 86.537 35.8644C86.2772 35.4599 86.1431 34.9874 86.1518 34.5067C86.1605 34.026 86.3115 33.5586 86.5858 33.1637C86.8601 32.7689 87.2453 32.4642 87.6927 32.2882C88.1402 32.1123 88.6297 32.0729 89.0995 32.1752C89.5693 32.2775 89.9982 32.5168 90.332 32.8628C90.6658 33.2088 90.8895 33.6461 90.9748 34.1193C91.0875 34.7536 90.9445 35.4068 90.5769 35.9359C90.2094 36.4651 89.6473 36.8272 89.0135 36.9431Z",
    fill: "#FB7BAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1671 38.7088C78.6939 38.7928 78.2065 38.7347 77.7663 38.5418C77.3261 38.3489 76.953 38.0299 76.6941 37.625C76.4352 37.2202 76.302 36.7477 76.3115 36.2672C76.321 35.7867 76.4727 35.3198 76.7474 34.9255C77.0222 34.5312 77.4076 34.2272 77.855 34.0518C78.3025 33.8765 78.7919 33.8377 79.2613 33.9403C79.7308 34.043 80.1593 34.2825 80.4928 34.6285C80.8262 34.9746 81.0496 35.4118 81.1347 35.8848C81.1921 36.1995 81.1867 36.5225 81.1188 36.8351C81.0509 37.1478 80.9217 37.4439 80.7388 37.7064C80.5559 37.9689 80.3229 38.1926 80.0531 38.3647C79.7834 38.5367 79.4822 38.6537 79.1671 38.7088Z",
    fill: "#FB7BAB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.3644,
    y: 32.7946,
    width: 26.2101,
    height: 20.143,
    rx: 4.61104,
    transform: "rotate(-9.86 39.3644 32.7946)",
    stroke: "#BF6DF9",
    strokeWidth: 2.91224
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9077 26.9854C16.6582 26.9842 16.4113 26.9348 16.1804 26.8399L15.4968 26.5781C15.0846 26.423 14.6531 26.2581 14.1925 26.069C13.7367 26.2581 13.3052 26.423 12.8882 26.5781L12.19 26.8496C11.9643 26.9371 11.7242 26.9815 11.4821 26.9806C11.2117 26.9832 10.9435 26.9314 10.6936 26.8281C10.4436 26.7248 10.2171 26.5721 10.0275 26.3793C9.8661 26.2196 9.73966 26.0281 9.65619 25.8169C9.57273 25.6057 9.53405 25.3795 9.54263 25.1526C9.57172 24.498 9.62021 23.7513 9.70263 22.9416C9.20597 22.3586 8.74453 21.7466 8.32077 21.1087C8.15354 20.8409 8.04845 20.5389 8.01321 20.2251C7.97797 19.9113 8.01347 19.5936 8.11712 19.2953C8.19533 19.045 8.33 18.816 8.51075 18.626C8.6915 18.436 8.91349 18.2901 9.15958 18.1995C9.89446 17.9665 10.6425 17.777 11.3997 17.6322C11.7797 16.945 12.2125 16.2885 12.6943 15.6684C12.8817 15.4609 13.11 15.2944 13.3649 15.1794C13.6198 15.0643 13.8957 15.0033 14.1754 15.0001C14.455 14.9969 14.7323 15.0517 14.9897 15.1608C15.2472 15.27 15.4792 15.4313 15.6713 15.6345C16.1623 16.265 16.6033 16.933 16.9902 17.6322C17.7427 17.7765 18.4859 17.9659 19.2157 18.1995C19.4644 18.2906 19.6893 18.4371 19.8732 18.6277C20.0571 18.8184 20.1954 19.0483 20.2776 19.3002C20.3815 19.5973 20.4176 19.914 20.3832 20.227C20.3488 20.5399 20.2448 20.8412 20.0788 21.1087C19.6322 21.7537 19.1464 22.3707 18.6242 22.9561C18.7066 23.7658 18.7551 24.5126 18.7842 25.1671C18.7936 25.3941 18.7554 25.6206 18.6719 25.8319C18.5883 26.0432 18.4614 26.2347 18.2993 26.3939C18.1099 26.5873 17.8835 26.7407 17.6336 26.8448C17.3837 26.949 17.1154 27.0017 16.8447 27L16.9077 26.9854Z",
    fill: "#D29400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1516 20.498C19.2146 20.3987 19.2572 20.2877 19.2769 20.1717C19.2966 20.0557 19.293 19.937 19.2664 19.8224C19.2398 19.7078 19.1906 19.5996 19.1218 19.5042C19.053 19.4087 18.9659 19.3279 18.8656 19.2665C18.1495 19.0416 17.421 18.8586 16.6837 18.7186C16.5599 18.6949 16.4428 18.6445 16.3406 18.5708C16.2384 18.4971 16.1536 18.4019 16.0921 18.2919C15.726 17.615 15.3095 16.9667 14.846 16.3524C14.6694 16.1982 14.4429 16.1133 14.2084 16.1133C13.974 16.1133 13.7475 16.1982 13.5708 16.3524C13.1074 16.9667 12.6908 17.615 12.3247 18.2919C12.2627 18.4005 12.1784 18.4947 12.0772 18.5683C11.9761 18.6418 11.8605 18.6931 11.738 18.7186C10.9937 18.8558 10.2585 19.0388 9.53673 19.2665C9.11005 19.4168 9.00823 20.115 9.25551 20.498C9.67962 21.12 10.1428 21.7143 10.6422 22.2775C10.7242 22.3692 10.7863 22.4768 10.8247 22.5936C10.8631 22.7105 10.8769 22.8339 10.8653 22.9564C10.778 23.7806 10.7247 24.537 10.6956 25.2013C10.6713 25.6862 11.3356 26.0062 11.8011 25.8171C12.4362 25.565 13.115 25.3322 13.8617 25.0122C14.085 24.9268 14.3319 24.9268 14.5551 25.0122C15.3018 25.3225 15.9806 25.565 16.6158 25.8171C17.1006 26.0062 17.7455 25.7056 17.7213 25.2013C17.6922 24.537 17.6388 23.7806 17.5516 22.9564C17.5414 22.834 17.5559 22.7109 17.5942 22.5943C17.6325 22.4777 17.6939 22.37 17.7746 22.2775C18.2716 21.7148 18.7316 21.1204 19.1516 20.498Z",
    fill: "#FFD880"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7739 82.0733C80.3811 84.5727 88.574 80.432 91.0733 72.8249C93.5727 65.2178 89.4321 57.0249 81.8249 54.5255C74.2178 52.0261 66.0249 56.1668 63.5255 63.7739C61.0262 71.381 65.1668 79.574 72.7739 82.0733Z",
    fill: "#FFD880"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2597_14469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2757 73.9398C91.3646 67.9649 89.0251 60.6173 83.0503 57.5284C77.0755 54.4395 69.7279 56.7791 66.639 62.7539C63.5502 68.7287 65.8897 76.0763 71.8645 79.1652C77.8393 82.2541 85.1869 79.9146 88.2757 73.9398Z",
    fill: "#D29400"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0246 78.2264C83.4519 77.7895 87.4976 73.0356 87.0608 67.6083C86.6239 62.1809 81.8701 58.1354 76.4428 58.5722C71.0154 59.0091 66.9698 63.763 67.4066 69.1904C67.8434 74.6177 72.5973 78.6633 78.0246 78.2264Z",
    fill: "#FFCA2D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2597_14469",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 67,
    y: 58,
    width: 21,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.027 78.2254C83.4544 77.7885 87.5 73.0346 87.0632 67.6073C86.6264 62.18 81.8726 58.1344 76.4452 58.5713C71.0179 59.0081 66.9723 63.762 67.4091 69.1894C67.8459 74.6167 72.5997 78.6623 78.027 78.2254Z",
    fill: "#FFCA2D"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2597_14469)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2597_14469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.3603 65.7603C71.4187 68.6264 73.0516 71.7429 75.9204 72.7291L86.3209 76.1462L87.1202 73.7135L76.9427 70.3696C75.3615 69.8501 74.3114 68.0972 74.8264 66.5297C75.3414 64.9622 77.0406 64.1126 78.6219 64.6321C80.2031 65.1517 81.0673 66.8435 80.5523 68.411C80.2045 69.4695 79.3168 70.2006 78.29 70.4039L81.5167 71.4641C82.141 70.8639 82.6312 70.1079 82.9198 69.2297C83.8695 66.339 82.2757 63.219 79.3598 62.2609C76.4438 61.3028 73.3101 62.8696 72.3603 65.7603Z",
    fill: "#D29400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7463 68.6623C71.9684 69.9545 72.6501 71.1415 73.6728 71.9906L65.3846 69.2675L66.1839 66.8348L71.7463 68.6623Z",
    fill: "#D29400"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2597_14469",
    x: 98.4658,
    y: 34.3877,
    width: 34.7434,
    height: 35.241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.497382
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.410841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_14469"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2597_14469",
    x: 98.8501,
    y: 42.7705,
    width: 28.3684,
    height: 23.4627,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.497382
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.410841
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_14469"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2597_14469",
    x: 65.2764,
    y: 56.1655,
    width: 24.3621,
    height: 24.711,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.348695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_14469"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2597_14469",
    x: 65.3845,
    y: 61.9795,
    width: 21.7356,
    height: 14.5157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.348695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.288025
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2597_14469"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2597_14469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105.042,
    height: 71.7147,
    fill: "white",
    transform: "translate(0 3.67334) rotate(-2.00393)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.6db3461dbd0fd3fb131627709ee876a8.svg";
export { ForwardRef as ReactComponent };